import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DateTime } from 'luxon';
import { filter, Subscription } from 'rxjs';
import { SegovPage } from 'src/app/app.routes';
import { CalendarComponent } from 'src/app/controls/calendar/calendar.component';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { CalendarioPublicacoesOutputDto } from 'src/app/domain/DTOs/output/calendario-publicacoes.output.dto';
import { DescricaoCalendario } from 'src/app/domain/enums/descricao-calendario.enum';
import { ETipoCalendario } from 'src/app/domain/enums/tipo-calendario.enum';
import { Cronogramas } from 'src/app/domain/modelsForComponents/cronograma.model';
import { TransferirDadosParaEdicaoDoDiaParams } from 'src/app/domain/routeParamsModels/transferir-dados-para-edicao-do-dia.params';
import { obterCalendarioPublicacao, obterCalendarioPublicacaoFinish } from 'src/app/stateManagement/actions/obter-calendarios-publicacoes.action';
import { ObterCalendariosPublicacoesState } from 'src/app/stateManagement/reducers/obter-calendarios-publicacoes.reducer';
import { selectDadosObterCalendariosPublicacoes } from 'src/app/stateManagement/selectors/obter-calendarios-publicacoes.selector';
import { ComponentMessages } from 'src/app/utils/component.messages';

@Component({
  selector: 'app-calendario-publicacoes-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,

    CalendarComponent,

    CommonModule
  ],
  templateUrl: './calendario-publicacoes-page.component.html',
  styleUrl: './calendario-publicacoes-page.component.css'
})
export class CalendarioPublicacoesPageComponent implements OnInit, OnDestroy {
  public titulo = ComponentMessages.centralDeRelacionamento;

  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Atendimento", route: SegovPage.CalendarioPublicacao },
    { title: "Calendário", route: SegovPage.CalendarioPublicacao }
  ];

  public DataApresentada: DateTime = DateTime.local();
  public LimiteMinData: DateTime = DateTime.fromJSDate(this.primeiroDiaDoAno(DateTime.local().year));
  public LimiteMaxData: DateTime = DateTime.fromJSDate(this.ultimoDiaDoAno(DateTime.local().year));
  public TipoCalendario: ETipoCalendario = ETipoCalendario.exibicaoPublicacoes;
  public Cronogramas: Cronogramas = {
    "2025-01-28": [DescricaoCalendario.PublicaoNormal],
    "2025-01-30": [DescricaoCalendario.SemPublicacao],
  };
  public dadosCalendario: CalendarioPublicacoesOutputDto;
  private subObterCalendarioPublicacoes: Subscription;

  constructor(
    private readonly storeObterCalendarioPublicacoes: Store<{ obterCalendarioPublicacoesState: ObterCalendariosPublicacoesState }>,
    private readonly router: Router
  ) {
    this.dadosCalendario = new CalendarioPublicacoesOutputDto();
    this.subObterCalendarioPublicacoes = new Subscription();
  }

  ngOnInit(): void {
    this.subObterCalendarioPublicacoes = this.storeObterCalendarioPublicacoes.select(selectDadosObterCalendariosPublicacoes)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        if(response && response.dados){
          this.dadosCalendario = response?.dados;
          this.Cronogramas = this.mapDatasSemPublicacaoToCronogramas(this.dadosCalendario.datasSemPublicacao);
        }
      });

    this.getCalendariosPublicacoes(new Date().getMonth() + 1);
  }

  ngOnDestroy(): void {
    this.subObterCalendarioPublicacoes.unsubscribe();
    this.storeObterCalendarioPublicacoes.dispatch(obterCalendarioPublicacaoFinish());
  }

  public onMudancaDeMes($event: DateTime) {
    this.getCalendariosPublicacoes($event.month);
  }

  public obterDataComunicadoEMudarPagina($event: Date){
    const dadosParaEdicaoDoDia : TransferirDadosParaEdicaoDoDiaParams = {
      dataPublicacaoSelecionada: $event
    };
    this.goToEdicaoDoDia(dadosParaEdicaoDoDia);
  }

  private getCalendariosPublicacoes(inputDto: number){
    this.storeObterCalendarioPublicacoes.dispatch(obterCalendarioPublicacao({inputDto}));
  }

  private primeiroDiaDoAno(year: number): Date {
    return new Date(year, 0, 1);
  }

  private ultimoDiaDoAno(year: number): Date {
    return new Date(year, 11, 31);
  }

  private goToEdicaoDoDia(parametros: TransferirDadosParaEdicaoDoDiaParams){
    this.router.navigate([SegovPage.EdicaoDoDia], {queryParams: {dados: JSON.stringify(parametros)}})
  }

  private mapDatasSemPublicacaoToCronogramas(datasSemPublicacao: Date[]): Cronogramas {
    const cronogramas: Cronogramas = {};

    datasSemPublicacao.forEach((date:Date) => {
      const dataConvertida = new Date(date);
      const key = dataConvertida.toISOString().split('T')[0];
      const descricao: DescricaoCalendario = DescricaoCalendario.SemPublicacao;
      if (!cronogramas[key])
        cronogramas[key] = [];
      cronogramas[key].push(descricao);
    });

    return cronogramas;
  }
}
